import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DigitalAcceptanceModalComponent } from 'src/app/components/digital-acceptance-modal/digital-acceptance-modal.component';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import { RejectedAlertComponent } from 'src/app/components/rejected-alert/rejected-alert.component';
import { RejectedReason } from 'src/app/models/rejected-reason-alert.models';
import { AceiteDigitalService } from 'src/app/services/aceite-digital.service';
import { AuthService } from 'src/app/services/auth.service';
import { PdfService } from 'src/app/services/pdf.service';
import { PropostaSalarialService } from 'src/app/services/proposta-salarial.service';
import { CO_STATUS_CONST } from 'src/app/utils/utils';

export interface OfferPdfPreviewData {
  blob: Blob;
}

export interface OfferPdfPreviewResult {
  nextSlideEvent?: number;
}

@Component({
  selector: 'hr-offer-pdf-preview-modal',
  templateUrl: './offer-pdf-preview-modal.component.html',
  styleUrls: ['./offer-pdf-preview-modal.component.scss'],
})
export class OfferPdfPreviewModalComponent implements OnInit, OnDestroy {
  @ViewChild('olPdfAcceptance', { static: true })
  olPdfAcceptance!: OlPdfAcceptanceComponent;

  pdfUrl: SafeResourceUrl;
  isLoading = false;
  disabledBttns: boolean;
  aceito = CO_STATUS_CONST.ACEITO;

  private objectUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: OfferPdfPreviewData,
    private dialogRef: MatDialogRef<
      OfferPdfPreviewModalComponent,
      OfferPdfPreviewResult
    >,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    public propostaService: PropostaSalarialService,
    private aceiteDigitalService: AceiteDigitalService,
    private pdfService: PdfService
  ) {}

  ngOnInit(): void {
    this.disabledBttns = this.authService.isPreview ? true : false;
    this.objectUrl = URL.createObjectURL(this.data.blob);
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.objectUrl
    );
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  async onAcceptOffer(): Promise<void> {
    if (!this.aceiteDigitalService.currentDigitalAcceptance) {
      await this.finishAccept(false);
      return;
    }

    this.dialog
      .open(DigitalAcceptanceModalComponent, {
        width: '521px',
        height: '414px',
        panelClass: ['hr-confirmation-modal'],
        backdropClass: 'hr-modal-backdrop',
      })
      .afterClosed()
      .subscribe(async (accepted?: boolean) => {
        if (accepted) {
          await this.finishAccept(true);
        }
      });
  }

  openModalRejectOffer(): void {
    this.dialog
      .open(RejectedAlertComponent, {
        panelClass: ['hr-modal', 'hr-thin-modal', 'hr-modal-reject'],
        backdropClass: 'hr-modal-backdrop-close',
      })
      .afterClosed()
      .subscribe(async (reason?: RejectedReason) => {
        if (reason) {
          await this.finishReject(reason);
        }
      });
  }

  private async finishAccept(shouldSaveAcceptance: boolean): Promise<void> {
    this.isLoading = true;
    try {
      await this.propostaService.aceitarOferta(shouldSaveAcceptance);
      await this.pdfService.processAndUploadPdf(
        this.olPdfAcceptance,
        CO_STATUS_CONST.ACEITO
      );
    } catch {
      // PDF failure does not block the acceptance flow
    } finally {
      this.isLoading = false;
      this.dialogRef.close({});
    }
  }

  private async finishReject(reason: RejectedReason): Promise<void> {
    this.isLoading = true;
    try {
      await this.propostaService.recusarOferta(reason);
      await this.pdfService.processAndUploadPdf(
        this.olPdfAcceptance,
        CO_STATUS_CONST.RECUSADO
      );
    } catch {
      // PDF failure does not block the rejection flow
    } finally {
      this.isLoading = false;
      this.dialogRef.close({ nextSlideEvent: 2 });
    }
  }
}
